import { useEffect, useState } from "react";

import loginbg from "../Assets/login-background.png";
import "./login.css";

import EyeIcon from "@mui/icons-material/VisibilityOutlined";
import EyeOffIcon from "@mui/icons-material/VisibilityOffOutlined";

import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";

import { useForm } from "react-hook-form";

import {
  Box,
  Button,
  Stack,
  TextField,
  InputAdornment,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import ReactHtmlParser from "html-react-parser";
import AuthLayout from "../Layout/AuthLayout";
import { resetPlan } from "../../store/Slices/paymentSlice";
import { useDispatch } from "react-redux";
import { fetchExchangeRates } from "../../store/Slices/exchangeRatesSlice";

const Login = ({ globalEvent, setGlobalEvent, title }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
  });

  const navigate = useNavigate();

  const mql = window.matchMedia("(max-width: 600px)");


  const onSubmit = (data, e) => {
    dispatch(resetPlan());
    doLogin(e, data);
    //console.log(data, e);
  };
  const onError = (errors, e) => {
    //console.log(errors, e);
  };

  const [password, setPassword] = useState("");
  const [type, setType] = useState("password");
  const [visibility, setVisibility] = useState(true);

  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [searchParams, setSearchParams] = useSearchParams();
  
  useEffect(() => {
    if (window.location.pathname == "/login") {

      if (searchParams.get("invitationToken"))
        setGlobalEvent({
          type: "setInvitedToken",
          data: { invitedToken: searchParams.get("invitationToken") },
        });
      if (searchParams.get("referralToken"))
        setGlobalEvent({
          type: "setReferralToken",
          data: { referralToken: searchParams.get("referralToken") },  
        });
    }
  }, [searchParams]);


  useEffect(() => {
    setTimeout(() => {
      window.AppleID.auth.init({
        clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
        scope: "name email",
        redirectURI: process.env.REACT_APP_CLIENT_URL,
        state: "SignInUserAuthenticationRequest",
        nonce: String(Date.now()),
        usePopup: true,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("googleButtonDiv"),
        {
          theme: "outline",
          size: "large",
          shape: "circle",
          width: (window.screen.width<= 900 ? "310" : "375"),
          logo_alignment: "center",
        }
      );
    }, 300);
  });

  useEffect( () => {
    window.scrollTo(0, 0);
    dispatch(fetchExchangeRates());
  }, [location.pathname]);

  useEffect(() => {
    if (process.env.REACT_APP_LOG_MESSAGELOG == "on") {
      //console.log("------ Global Event ------ Login");
      //console.log(globalEvent);
      //console.log("------------");
    }

    if (globalEvent?.type == "responseLoginError") {
      if (globalEvent?.data.hasOwnProperty("message")) {
        setGlobalEvent({ type: "showToast", data: globalEvent?.data });
      } else {
        if (globalEvent?.data.hasOwnProperty("errors")) {
          let msg = globalEvent?.data.errors[0].code ?? globalEvent?.data?.errors[0].message;
          setGlobalEvent({
            type: "showToast",
            data: {
              toastType: "error",
              message: t("errors.login." + msg),
            },
          });
        } else {
          setGlobalEvent({
            type: "showToast",
            data: { message: globalEvent?.data },
          });
        }
      }
    }
  }, [globalEvent]);

  const fpwdPage = () => {
    navigate("/forgot-password");
  };

  const goHome = (event, data) => {
    event.stopPropagation();
    setGlobalEvent({ type: "goHome", data: data });
  };

  const showToast = (event, data) => {
    event.stopPropagation();
    setGlobalEvent({ type: "showToast", data: data });
  };

  const showConfirm = (event, data) => {
    event.stopPropagation();
    setGlobalEvent({ type: "showConfirm", data: data });
  };

  const showMessage = (event, data) => {
    event.stopPropagation();
    setGlobalEvent({ type: "showMessage", data: data });
  };

  const doPing = (event, data) => {
    event.stopPropagation();
    setGlobalEvent({ type: "doPing", data: data });
  };

  const doLogin = (event, data) => {
    event.stopPropagation();
    setGlobalEvent({ type: "doLogin", data: data });
  };

  return (
    <>
      <AuthLayout
        backgroundImage={loginbg}
        globalEvent={globalEvent}
        setGlobalEvent={setGlobalEvent}
      >
        <div className="login-container">
          <Box
            sx={{
              mt: 16,

              px: { xs: 2, md: 0 },
            }}
          >
            <Box>
              <Typography
                variant="h6"
                sx={{
                  mb: 4,
                  width: "100%",
                  textAlign: "start",
                }}
              >
                {ReactHtmlParser(t("login.title"))}
              </Typography>
            </Box>
            <Stack
              direction="column"
              spacing={6}
              sx={{
                mt: { xs: 0, sm: 4 },
				justifyContent: "center",
				alignItems: "center",
              }}
            >
              <div
                id="googleButtonDiv"
                className="google-btn"
                data-context="signin"
                data-ux_mode="popup"
                data-auto_prompt="false"
              ></div>

              <div
                id="appleid-signin"
                className="signin-button apple-btn"
                data-color="black"
                data-border="true"
                data-type="sign-in"
                data-border-radius="50"
                data-height="44"
              ></div>
            </Stack>
            <Typography
              width="100%"
              variant="body2"
              sx={{
                mt: 6,
                color: "#7C7C7C",
                display: "flex",
                flexDirection: "row",
                "&:before, &:after": {
                  color: "#7C7C7C",
                  content: `""`,
                  flex: `1 1`,
                  borderBottom: 2,
                  margin: "auto",
                },
                "&:before": {
                  mr: 2,
                },
                "&:after": {
                  ml: 2,
                },
              }}
            >
              {ReactHtmlParser(t("common.or"))}
            </Typography>
            <Box
              sx={{
                mt: 3,
              }}
            >
              <Box component="form" onSubmit={handleSubmit(onSubmit, onError)}>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                  <TextField
                    key="email"
                    className="fullwidth-field"
                    sx={{ maxWidth: {xs:"310px", md: "100%"}, minWidth: "310px"}}
                    label={ReactHtmlParser(t("field.email"))}
                    type="email"
                    {...register("email", {
                      required: t("errors.field.required"),
                      pattern: {
                        value: /\S+@\S+\.\S+/,
                        message: ReactHtmlParser(t("changeemail.error")),
                      },
                    })}
                  />

                  {errors.email && (
                    <span role="alert">{errors.email.message}</span>
                  )}

                  <TextField
                    key="password"
                    className="fullwidth-field"
                    sx={{ maxWidth: {xs:"310px", md: "100%"}, minWidth: "310px"}}
                    label={ReactHtmlParser(t("field.password"))}
                    type={type}
                    {...register("password", {
                      required: t("errors.field.required"),
                    })}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment sx={{mt: -1.5}} position="end">
                          <IconButton
                            onClick={(e) => {
                              setType(visibility ? "text" : "password");
                              setVisibility(!visibility);
                            }}
                          >
                            {visibility ? <EyeIcon /> : <EyeOffIcon />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors.password && (
                    <span role="alert">{errors.password.message}</span>
                  )}

                  <Grid
                    container
                    direction={{ xs: "column-reverse", md: "row" }}
                    spacing={2}
                    sx={{
                      mt: 4,
                      alignItems: "center",
                      ml: {xs: "0px!important", md: "-16px!important"}
                    }}
                  >
                    <Grid item md={1} sm={{
                      display: {xs: 'none', sm: 'block'}
                    }} ></Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{
                        textAlign: { xs: "center", md: "left" },
                        pl: "0px!important",
                      }}
                    >
                      <Button
                        className="secondary-blue-text-btn"
                        variant="text"
                        sx={{ lineHeight: "20.16px", color: "primary.light" }}
                        onClick={(e) => {
                          fpwdPage(e, {});
                        }}
                      >
                        {ReactHtmlParser(t("common.buttonforgotpwd"))}
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={5}
                      sx={{ display: "flex", justifyContent: { xs: "center", md: "end" }, pl: {xs: "0px!important", md: "16px!important"}, }}
                    >
                      <Button
                        className="secondary-blue-btn"
                        type="submit"
                        variant="contained"
                        sx={{
                          lineHeight: "20.16px",
                          my: 3,
                          py: 2,
                          px: 4,
						  minWidth: { xs: "310px", md: "auto" },
                          width: { xs: "310px", md: "auto"},
                        }}
                        endIcon={
                          <svg
                            width="12"
                            height="9"
                            viewBox="0 0 12 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.2929 5H0.5C0.223858 5 0 4.77614 0 4.5C0 4.22386 0.223858 4 0.5 4H10.2929L7.14645 0.853553C6.95118 0.658291 6.95118 0.341709 7.14645 0.146447C7.34171 -0.0488155 7.65829 -0.0488155 7.85355 0.146447L11.8536 4.14645C12.0488 4.34171 12.0488 4.65829 11.8536 4.85355L7.85355 8.85355C7.65829 9.04882 7.34171 9.04882 7.14645 8.85355C6.95118 8.65829 6.95118 8.34171 7.14645 8.14645L10.2929 5Z"
                              fill="#E5FE4A"
                            />
                          </svg>
                        }
                      >
                        {ReactHtmlParser(t("common.buttondologin"))}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Box>
              <Stack
                direction={"row"}
                spacing={1}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 4,
                  mb: 6,
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.95 19C16.7184 20.1411 15.7095 21 14.5 21H5.5C4.11929 21 3 19.8807 3 18.5V11.5C3 10.2905 3.85888 9.28164 5 9.05001V8C5 5.23858 7.23858 3 10 3C12.7614 3 15 5.23858 15 8V9.05001C16.1411 9.28164 17 10.2905 17 11.5V13H18.5C19.8807 13 21 14.1193 21 15.5V16.5C21 17.8807 19.8807 19 18.5 19H16.95ZM15.9146 19H11.5C10.1193 19 9 17.8807 9 16.5V15.5C9 14.1193 10.1193 13 11.5 13H16V11.5C16 10.7105 15.39 10.0634 14.6157 10.0044C14.5785 10.0132 14.5398 10.0178 14.5 10.0178C14.454 10.0178 14.4095 10.0116 14.3672 10H5.5C4.67157 10 4 10.6716 4 11.5V18.5C4 19.3284 4.67157 20 5.5 20H14.5C15.1531 20 15.7087 19.5826 15.9146 19ZM14 9H6V8C6 5.79086 7.79086 4 10 4C12.2091 4 14 5.79086 14 8V9ZM20 16.5V15.5C20 14.6716 19.3284 14 18.5 14H11.5C10.6716 14 10 14.6716 10 15.5V16.5C10 17.3284 10.6716 18 11.5 18H18.5C19.3284 18 20 17.3284 20 16.5ZM12.5 15H11.5C11.2239 15 11 15.2239 11 15.5V16.5C11 16.7761 11.2239 17 11.5 17H12.5C12.7761 17 13 16.7761 13 16.5V15.5C13 15.2239 12.7761 15 12.5 15ZM15.5 15C15.7761 15 16 15.2239 16 15.5V16.5C16 16.7761 15.7761 17 15.5 17H14.5C14.2239 17 14 16.7761 14 16.5V15.5C14 15.2239 14.2239 15 14.5 15H15.5ZM18.5 15H17.5C17.2239 15 17 15.2239 17 15.5V16.5C17 16.7761 17.2239 17 17.5 17H18.5C18.7761 17 19 16.7761 19 16.5V15.5C19 15.2239 18.7761 15 18.5 15Z"
                    fill="#BBBBBB"
                  />
                </svg>
                <Typography variant="caption">
                  {ReactHtmlParser(t("common.labelsecurestorage"))}
                </Typography>
              </Stack>
            </Box>
          </Box>
        </div>
      </AuthLayout>
    </>
  );
};

export default Login;
